import { post } from 'api/apiRequest';
import { jsonFetchGet } from 'api/jsonFetch/authJsonFetch';
import { UsersLogsData } from 'reducer/usersLogsReducer';

export const userLogsApi = {
  track: () => post(`/v1/UserLog/track`, {}),
  getLastActivity: () => jsonFetchGet<UsersLogsData[]>(`/v1/UserLog/lastActivity`),
};
